if (!customElements.get('component-pages-sidebar-menu')) {

    class ComponentPagesSidebarMenu extends HTMLElement {
        constructor() {
            super();

            this._isOpened = false;
        }

        connectedCallback() {
            this.currentItem = this.querySelector('.page-sidebar__current-item');
            this.addListeners();
        }

        addListeners() {
            this.customDelegate(
                "click",
                '.page-sidebar__current-item',
                this.fieldClickHandler.bind(this)
            )
        }

        toggleDropdown(show) {
            show = (show !== undefined) ? show : !this._isOpened;
            this._isOpened = show;
            this._isOpened ? this.setAttribute('open', '') : this.removeAttribute('open');
        };

        fieldClickHandler() {
            this._isOpened ? this.close() : this.open();
        };

        close() {
            this.toggleDropdown(false);
        };

        open() {
            this.toggleDropdown(true);
        }

        customDelegate(eventName, elementSelector, handler) {
            this.addEventListener(eventName, (e) => {
                const element = e.target.closest(elementSelector);

                if (element) {
                    handler.call(element, e, element);
                }
            }, false);
        };
    }

    customElements.define('component-pages-sidebar-menu', ComponentPagesSidebarMenu);
}